import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import SuppliersTable from "@/components/suppliers/suppliers-table";

const suppliersSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/suppliers/")({
  validateSearch: suppliersSearchSchema,
  component: SuppliersPage,
});

function SuppliersPage() {
  const searchParams = Route.useSearch();

  return (
    <div className="space-y-4">
      <SuppliersTable
        currentPage={searchParams.page}
        basePath="/suppliers"
        searchParams={searchParams}
      />
    </div>
  );
}
